<div class="p-a-xl">
    <app-data-cards-view [screentype]="screenType" [rows]="rows" [actions]="actions" [isLoading]="false" />
</div>
